class Gate {
    static path = 'logic/gate';

    constructor(mutator){
        this.addInput("Condition", "boolean");
        this.addInput("Pass-through data", "");
        this.addOutput("data", "nooutput");
        this.bgcolor = '#9fe2fc';
        this.title = 'Continue If True/False';
        this.desc = 'Continue this branch only if the condition is false';
        this.properties = {selected: ''};

        this.addWidget("combo","",this.properties.selected,(v) => {
            this.properties.selected = v;
            if(v !== '') {
                this.title = 'Continue If ' + v;
            } else {
                this.title = 'Continue If True/False'
            }
            this.triggerSlot(0, v);
        },{ property: "selected", values: ['True', 'False'] } );
    }

    onConnectionsChange(type, slot) {
        if(type === 1 && slot === 1) { //LiteGraph.INPUT
            let parent_node = this.getParentNode(1);
            if (!parent_node) {
                this.outputs[0].type = 'nooutput';
                this.disconnectOutput(0);
                return;
            }

            if(this.outputs[0].type !== parent_node.outputs[0].type)
                this.disconnectOutput(0);
            this.outputs[0].type = parent_node.outputs[0].type;
        }
    }
}

module.exports = Gate
